(() => {
  function initialize() {
    const root = document.getElementById('NeLoyaltyContent');
    const dialog = root?.querySelector('#LoyaltyModal');
    if (!dialog || dialog.dataset.loyaltyReady || !root.querySelector('[data-loyalty-continue]')) return;
    dialog.dataset.loyaltyReady = 'true';
    const eraseCookie = (name) => {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    };

    const continueButton = root.querySelector('[data-loyalty-continue]');
    const skipButton = root.querySelector('[data-loyalty-skip]');
    const modalToggles = root.querySelectorAll('[data-loyalty-modal-toggle]');
    const modal = root.querySelector('[data-loyalty-modal]');

    const confirmRejectButton = root.querySelector('[data-loyalty-confirm-reject]');

    const customerId = String(window.customer.id);
    const customerEmail = window.customer.email;

    // The rewards page requires explicit enrollment; other pages allow Skip.
    if (window.location.pathname.startsWith('/pages/rewards')) {
      continueButton.setAttribute('disabled', 'disabled');
      root.querySelector('.loyalty-opt__skip').style.display = 'none';
      root.querySelector('#loyalty_opt-in').addEventListener('change', (event) => {
        continueButton.disabled = !event.target.checked;
      });
    }

    const refreshCustomerPage = async () => {
      dialog.close();
      eraseCookie('loyalty_return_to');
      eraseCookie('nec_exclusive_collection');
      eraseCookie('loyalty_exclusive_product');
      try { await window.NECustomerSession.refresh(); }
      catch { window.location.reload(); }
    };

    let submitting = false;
    const submitAcceptance = async (status, tags, note) => {
      if (submitting) return;
      submitting = true;
      const buttons = [continueButton, skipButton, confirmRejectButton];
      const disabled = buttons.map((button) => button.disabled);
      buttons.forEach((button) => { button.disabled = true; });
      try {
        const response = await fetch('/apps/loyalty-program', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: customerId,
            email: customerEmail,
            status,
            tags: tags || '',
            note: note || '',
          }),
        });
        if (!response.ok) throw new Error('Rewards request failed');
        const result = await response.json();
        if (!result?.ok) throw new Error('Rewards update was not confirmed');
        await refreshCustomerPage();
      } catch {
        alert(window.themeStrings?.somethingWentWrongTryAgain ?? 'Something went wrong. Try again');
      } finally {
        submitting = false;
        buttons.forEach((button, index) => { button.disabled = disabled[index]; });
      }
    };

    continueButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const checked = root.querySelector('#loyalty_opt-in')?.checked;
      const tags = root.querySelector('#RegisterForm-birthday-tag')?.value;
      const note = root.querySelector('#RegisterForm-birthday-note')?.value;
      void submitAcceptance(checked ? 'accept' : 'reject', tags, note);
    });
    skipButton.addEventListener('click', () => { void submitAcceptance('skip'); });
    confirmRejectButton.addEventListener('click', () => { void submitAcceptance('reject'); });

    modalToggles.forEach((trigger) =>
      trigger.addEventListener('click', () => {
        modal.classList.toggle('open');
      })
    );
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  window.addEventListener('ne:customer-state', initialize);
})();
